import HelloSign from "hellosign-embedded";

interface UseHelloSignProps {
    onFinish?: () => void;
}

export const useHelloSign = ({ onFinish }: UseHelloSignProps) => {
    const environment = import.meta.env.REACT_APP_UI_ENV;
    const helloSignClientId = import.meta.env.REACT_APP_HELLO_SIGN_CLIENTID;
    const client = new HelloSign();

    const openHelloSign = (claimUrl: string, container?: HTMLElement) => {
        client.open(claimUrl, {
            clientId: helloSignClientId,
            skipDomainVerification: environment !== "Prod",
            container: container
        });

        client.on(HelloSign.events.FINISH, () => {
            if (onFinish) {
                onFinish();
            }
        });
    };

    return { openHelloSign };
};